import React, { VFC } from 'react'
import cn from 'classnames'
import styles from './InputText.module.css'
import { Icon, IconType } from '../../../Icon'

type Props = {
  iconLeft?: IconType | false
  rightText?: string
  error?: boolean
}

export const InputText: VFC<Props & React.HTMLProps<HTMLInputElement>> = ({
  iconLeft,
  rightText,
  error,
  ...otherProps
}) => {
  const { className } = otherProps

  return (
    <label className={cn([styles.root, className, error && styles.error])}>
      {iconLeft && <Icon icon={iconLeft} className={styles.left} />}
      <input
        {...otherProps}
        className={cn(styles.input, !!iconLeft && styles.withLeft)}
        type='text'
      />
      {rightText && <div className={styles.right}>{rightText}</div>}
    </label>
  )
}
